import { useEffect } from "react";
import { pushDataLayerEvent, sendGtagEvent } from "@/utils/tracking";

export default function GlobalWhatsAppTracking() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const link = target.closest(
        "a[href*='wa.me'], a[href*='whatsapp.com']",
      ) as HTMLAnchorElement | null;

      if (!link) return;

      pushDataLayerEvent("whatsapp_click", {
        page_path: window.location.pathname,
        link_url: link.href,
        link_text: link.textContent?.trim() || undefined,
      });

      sendGtagEvent("conversion", {
        send_to: "AW-17006649430/DnqHCMPB2agcENbAs60_",
        value: 1.0,
        currency: "SAR",
      });
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
}
